import { api } from '../../plugins/api'

export default {
    ChargeMembres(context, requestParams) {
        return new Promise((resolve, reject) => {
            api.post('contact/tableaudesmembres', requestParams)
                .then(response => {
                    resolve(response.data)

                    let paginator = JSON.parse(response.headers["x-pagination"]);

                    context.commit("Membres", response.data)


                    context.commit("Total", paginator.TotalCount)
                }).catch(error => console.log(error))
        })
    },
}